module.exports = __webpack_public_path__ + "img/owl-orange-front.03cba892.png";